module.exports = __webpack_public_path__ + "fonts/NeueHaasGroteskText-55Roman-Web.4e53be1.woff";